import React from 'react';
import classNames from 'classnames';

import { useSoyuzLocales } from '@spotahome/soyuz/client';

import { useFooterLinks } from '../../context/ExternalLink';
import { useLocaleChange } from '../../../hooks/useLocaleChange';
import LanguageSwitcher from '../LanguageSwitcher';

import TrustPilotIconFooter from './TrustPilotIconFooter';

import FooterSimplifiedSection from './components/FooterSimplifiedSection';
import FooterSimplifiedSeparator from './components/FooterSimplifiedSeparator';

import SpotahomeFooter from './SpotahomeFooter';
import LegalFooter from './LegalFooter';
import SupportFooter from './SupportFooter';
import SocialFooter from './SocialFooter';
import AppFooter from './AppFooter';

import CopyrightFooter from './CopyrightFooter';
import FooterSimplifiedBlock from './components/FooterSimplifiedBlock';

import styles from './FooterSimplified.module.scss';

const FooterSimplified = React.memo(() => {
  const externalLinks = useFooterLinks();
  const handleOnLocaleChange = useLocaleChange();
  const { current, ui: uiLocales } = useSoyuzLocales();

  return (
    <footer>
      <section className={classNames(styles.footer, styles['footer--beige'])}>
        <FooterSimplifiedSection>
          <SpotahomeFooter {...externalLinks} />
          <FooterSimplifiedBlock>
            <SupportFooter {...externalLinks} />
          </FooterSimplifiedBlock>
          <FooterSimplifiedBlock>
            <LegalFooter {...externalLinks} />
          </FooterSimplifiedBlock>
          <FooterSimplifiedBlock className={styles.footer__external}>
            <AppFooter />
            <TrustPilotIconFooter />
          </FooterSimplifiedBlock>
          <FooterSimplifiedBlock className={styles.footer__trustpilot}>
            <TrustPilotIconFooter />
          </FooterSimplifiedBlock>
          <FooterSimplifiedBlock className={styles.footer__app}>
            <AppFooter />
          </FooterSimplifiedBlock>
        </FooterSimplifiedSection>
      </section>
      <section
        className={classNames(
          styles.footer__disclaimer,
          styles['footer--disclaimer__beige']
        )}
      >
        <FooterSimplifiedSeparator />
        <FooterSimplifiedSection>
          <CopyrightFooter />
          <div className={styles.footer__language}>
            <LanguageSwitcher
              theme="dark"
              onChange={handleOnLocaleChange}
              locales={Object.keys(uiLocales)}
              current={current}
            />
            <SocialFooter />
          </div>
        </FooterSimplifiedSection>
      </section>
    </footer>
  );
});

export default FooterSimplified;
